import * as z from "zod";

export const getProductTitles = {
  name: "getProductTitles" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
